import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGridPremium, GridToolbar } from "@mui/x-data-grid-premium";
import { Box } from "@mui/material";

const QAFailedSales = ({ startDate, endDate, client, token }) => {
  console.log("QAFailedSales", startDate, endDate, client);

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pageSize, setPageSize] = useState(5);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/extracts/QAFailedQuestionsExtract?startDate=${startDate}&endDate=${endDate}&client=${client}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setData(response.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (startDate && endDate) {
      fetchData();
    }
  }, [startDate, endDate, client, token]);

  const columns = [
    {
      field: "order_id",
      headerName: "Order ID",
      width: 100,
    },
    {
      field: "client_order_ref",
      headerName: "Client Ref",
      width: 130,
    },
    {
      field: "sale_date",
      headerName: "Sale Date",
      width: 130,
      valueGetter: (params) =>
        new Date(params.row.sale_date).toLocaleDateString(),
    },
    {
      field: "agent",
      headerName: "Agent",
      width: 180,
    },
    {
      field: "qa_stage",
      headerName: "QA Stage",
      width: 120,
    },
    {
      field: "client",
      headerName: "Client",
      width: 120,
    },
    {
      field: "errors",
      headerName: "Errors",
      width: 400,
      flex: 1,
      renderCell: (params) => {
        const errors = params.value
          ? params.value.split("|").map((error) => error.trim())
          : [];
        return (
          <div
            style={{
              whiteSpace: "normal",
              wordBreak: "break-word",
              // lineHeight: "1.5",
              padding: "8px 4px",
            }}
          >
            {errors.length > 0
              ? errors.map((error, index) => (
                  <div
                    key={index}
                    style={{
                      marginBottom: index < errors.length - 1 ? "8px" : 0,
                      // backgroundColor: "#fff4f4",
                      padding: "8px",
                      borderRadius: "4px",
                    }}
                  >
                    {error}
                  </div>
                ))
              : "-"}
          </div>
        );
      },
    },
  ];

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div>
      {data && data.data.length > 0 ? (
        <Box sx={{ width: "100%", height: 600 }}>
          <h3>QA Failed Sales Report</h3>
          <DataGridPremium
            rows={data.data}
            columns={columns}
            getRowId={(row) => row.order_id}
            pagination
            autoHeight
            density="comfortable"
            slots={{ toolbar: GridToolbar }}
            pageSize={pageSize}
            onPageSizeChange={(newSize) => setPageSize(newSize)}
            checkboxSelection={false}
            initialState={{
              pagination: { paginationModel: { pageSize: 10 } },
            }}
            pageSizeOptions={[5, 10, 15, 20]}
            getDetailPanelHeight={() => "auto"}
            getRowHeight={() => "auto"}
            sx={{
              "& .MuiDataGrid-cell": {
                maxHeight: "none !important",
                overflow: "auto",
                whiteSpace: "normal",
              },
            }}
          />
        </Box>
      ) : (
        <p>No data available</p>
      )}
    </div>
  );
};

export default QAFailedSales;
